import styled, { css } from "styled-components";

// box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.25);

interface ContainerProps {
  shadowInset: boolean;
}

const Container = styled.div<ContainerProps>`
  background: #ffffff;
  box-shadow: ${({ shadowInset }) => (shadowInset
    ? css`inset 0px 0px 3px 1px rgba(0, 0, 0, 0.25)`
    : css`0px 1px 3px 1px rgba(0, 0, 0, 0.25);`)};
  border-radius: 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
  margin-bottom: 15px;
  min-height: 110px;
  
  &.action {
    cursor: pointer;
  }
  
  .userType {
    justify-content: space-between;
    width: 100%;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  
  button {
    background: transparent;
    border:none;
    cursor: pointer;
    
    svg {
      color: red;
    }
  }
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface IconContainerProps {
  color: string;
}

const IconContainer = styled.div<IconContainerProps>`
  margin-right: 15px;

  svg {
    fill: ${({ color }) => color};
  }
`;

interface InfoContainerProps {
  color?: string;
}

const InfoContainer = styled.div<InfoContainerProps>`
  font-size: 13px;
  font-weight: 400;
  color: #666666;

  .inlineContent {
    display: inline-flex;
    > div {
      margin-right: 5px;
    }
  }

  .titleContent {
    font-weight: 700;
    color: #000;
  }

  .contentColor {
    color: ${({ color }) => color};
    font-weight: 600;
  }
`;

interface ActionContainerProps {
  color?: string;
}

const ActionContainer = styled.div<ActionContainerProps>`
  svg {
    fill: ${({ color }) => color || "#BEBEBE"};
    cursor: pointer;
  }
`;

const UserCardContainer = styled.div`
  display: flex;
  width: 100%;
`;

export { Container, Content, IconContainer, InfoContainer, ActionContainer, UserCardContainer, ContentContainer };
